import { useState, useEffect, useCallback } from 'react'
export interface Note {
  id: string
  title: string
  content: string
  color: string
  updatedAt: string
  pinned: boolean
}
const STORAGE_KEY = 'vsm_personal_notes'
const DEFAULT_NOTES: Note[] = [
  {
    id: 'n1',
    title: 'Ideas para el Dashboard',
    content:
      '- Agregar widgets drag & drop\n- Integrar con Google Calendar\n- Mejorar el modo oscuro',
    color: 'bg-indigo-950/40 border-indigo-900/40',
    updatedAt: new Date().toISOString(),
    pinned: true,
  },
  {
    id: 'n2',
    title: 'Standup Notes (Jueves)',
    content:
      'Ayer: Terminé la auth con Cognito.\nHoy: Arranco con el widget de TODOs.\nBlockers: Ninguno.',
    color: 'bg-emerald-950/40 border-emerald-900/40',
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
    pinned: false,
  },
  {
    id: 'n3',
    title: 'Links Útiles',
    content:
      'Figma design: https://figma.com/...\nAPI Docs: https://api.docs.com/...',
    color: 'bg-amber-950/40 border-amber-900/40',
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
    pinned: false,
  },
]
export function usePersonalNotes() {
  const [notes, setNotes] = useState<Note[]>(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) return JSON.parse(stored)
    } catch (e) {
      console.error('Error loading notes', e)
    }
    return DEFAULT_NOTES
  })
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(notes))
  }, [notes])
  const addNote = useCallback((note: Omit<Note, 'id' | 'updatedAt'>) => {
    const newNote: Note = {
      ...note,
      id: Math.random().toString(36).substring(2, 9),
      updatedAt: new Date().toISOString(),
    }
    setNotes((prev) => [newNote, ...prev])
  }, [])
  const updateNote = useCallback((id: string, updates: Partial<Note>) => {
    setNotes((prev) =>
      prev.map((n) =>
        n.id === id
          ? {
              ...n,
              ...updates,
              updatedAt: new Date().toISOString(),
            }
          : n,
      ),
    )
  }, [])
  const removeNote = useCallback((id: string) => {
    setNotes((prev) => prev.filter((n) => n.id !== id))
  }, [])
  const togglePin = useCallback((id: string) => {
    setNotes((prev) =>
      prev.map((n) =>
        n.id === id
          ? {
              ...n,
              pinned: !n.pinned,
            }
          : n,
      ),
    )
  }, [])
  return {
    notes,
    addNote,
    updateNote,
    removeNote,
    togglePin,
  }
}
